import {observable, action} from 'mobx';
import _ from 'lodash';

class SampleContentStore {

  @observable sampleContentList = [];
  @observable sampleContent = _.assign({}, {
    title: '',
    file: null,
    video_url: '',
    type: 1,
  });
  @observable errors = {};

  @action
  setSampleContentList = sampleContentList => {
    this.sampleContentList = sampleContentList;
  };

  @action
  initNewSampleContent = () => {
   this.sampleContent = _.assign({}, {
      title: '',
      file: null,
      video_url: '',
      sample_type: 0,
    });
  };

  @action
  setError = errors => {
    this.errors = errors;
  };

  @action
  setSampleContent = sampleContent => {
    this.sampleContent = sampleContent;
  };

  @action
  updateSampleContent = sampleContent => {
    const allSampleContent = [...this.sampleContentList];
    let oldSampleContentIndex = allSampleContent.findIndex(e => e.id === sampleContent.id);
    allSampleContent[oldSampleContentIndex] = sampleContent;
    this.setSampleContentList(allSampleContent);
  }

  @action
  saveSampleContent = sampleContent => {
    const allSampleContent = [...this.sampleContentList];
    allSampleContent.push(sampleContent);
    this.setSampleContentList(allSampleContent);
  }

  getSampleContentById = id => {
    return this.sampleContentList.find(el => el.id === id);
  };

  @action
  handleUpdateSampleContent = newSampleContent => {
    let oldSampleContent = this.getSampleContentById(newSampleContent.id);
    _.assign(oldSampleContent, newSampleContent);
  };

  @action
  createSampleContent = sampleContent => {
    this.sampleContentList.unshift(sampleContent);
  };

  @action
  deleteSampleContent = id => {
    const allSampleContent = [...this.sampleContentList];
    let index = _.findIndex(allSampleContent, el => el.id === id);
    allSampleContent.splice(index, 1);
    this.setSampleContentList(allSampleContent);
  };

  @action
  sortSampleContent = sampleContentList => {
    return sampleContentList.sort((sampleContent_a, sampleContent_b) => sampleContent_a.title.localeCompare(sampleContent_b.title));
  }

  @action
  handleChange = data => {
    _.assign(this.sampleContent, data);
  }
}

export default new SampleContentStore();



// WEBPACK FOOTER //
// ./src/stores/SampleContentStore.js